module.exports = __webpack_public_path__ + "img/header.1d973f15.png";